import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Modal,
  Form as FormBootstrap,
  Button,
} from 'react-bootstrap';
import { Formik, Field, Form } from 'formik';

import { FORMAS_PAGAMENTO, CHEQUE } from '~/constant';
import * as api from '~/Services/Service';

import Boleto from './Boleto';
import Cheque from './Cheque';
import Cartao from './Cartao';
import Deposito from './Deposito';
import Dinheiro from './Dinheiro';
import formaPgtoValidate from './formaPgtoValidate';
import { toast } from 'react-toastify';
import { FaDollarSign, FaGavel } from 'react-icons/fa';

export default function ModalFormaPgto({
  show,
  onCancel,
  onSave,
  initialValues,
  cartoes,
  isContraProposta,
}) {
  const [erroValidacaoCheque, setErroValidacaoCheque] = useState(null);
  const [validandoCheque, setValidandoCheque] = useState(false);

  useEffect(() => setErroValidacaoCheque(null), [show]);
  const notificar = async () => {
    try {
      const response = await api.NotificarDepartamento('financeiro');
      toast.success('Departamento notificado');
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <Modal show={show} size="lg" onHide={onCancel}>
      <Formik
        initialValues={initialValues}
        onSubmit={async values => {
          if (values.tipo_parcela === CHEQUE) {
            setValidandoCheque(true);
            setErroValidacaoCheque(null);
            try {
              const response = await api.validarCheque(values[CHEQUE]);
              if (response.em_uso) setErroValidacaoCheque('Cheque em uso');
              else onSave(values);
            } catch (err) {
              setErroValidacaoCheque(err.message);
              console.error(err);
            } finally {
              setValidandoCheque(false);
            }
          } else {
            onSave(values);
          }
        }}
        validate={formaPgtoValidate}
        validateOnMount={true}
      >
        {({ values, isSubmitting, setFieldValue }) => (
          <Form>
            <Modal.Header closeButton>
              <div className="d-flex w-100 justify-content-between align-items-center">
                <span>
                  {initialValues.hasOwnProperty('index')
                    ? 'Editando'
                    : 'Adicionando'}{' '}
                  forma de pagamento
                </span>
                <Button
                  hidden
                  variant="light"
                  onClick={notificar}
                  className="ms-3"
                >
                  <FaDollarSign className=" mb-1 mr-2" />
                  Financeiro
                </Button>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <FormBootstrap.Group controlId="formaPagamento">
                    <FormBootstrap.Label>Forma Pgto.</FormBootstrap.Label>
                    <Field
                      name="tipo_parcela"
                      className="form-control"
                      as="select"
                      disabled={initialValues.hasOwnProperty('index')}
                      onChange={e =>
                        setFieldValue(e.target.name, parseInt(e.target.value))
                      }
                    >
                      <option value="">Selecione uma forma de pagamento</option>
                      {FORMAS_PAGAMENTO.map(item => (
                        <option value={item.value} key={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </Field>
                  </FormBootstrap.Group>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <Boleto />
                  <Cheque erroValidacaoCheque={erroValidacaoCheque} />
                  <Cartao
                    cartoes={cartoes}
                    isContraProposta={isContraProposta}
                  />
                  <Deposito />
                  <Dinheiro />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="link" type="button" onClick={onCancel}>
                Cancelar
              </Button>
              {values.tipo_parcela && (
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  {validandoCheque
                    ? 'Validando...'
                    : initialValues.hasOwnProperty('index')
                    ? 'Atualizar'
                    : 'Inserir'}
                </Button>
              )}
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
